var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"Trademark",domProps:{"innerHTML":_vm._s(_vm.$t('common.footer-003'))}})}
var staticRenderFns = []

export { render, staticRenderFns }